import { useTranslation } from 'react-i18next';

import {
  Heading,
  HStack,
  VStack,
} from '@dotfile/frontend/shared/design-system';

export const CaseHeader = () => {
  const { t } = useTranslation();

  return (
    <VStack spacing="6" width="full" align="stretch">
      <HStack
        justifyContent="space-between"
        spacing="4"
        width="full"
        flexWrap="wrap"
      >
        <Heading>
          {t(`onboardings.title`, {
            ns: 'client-portal',
            defaultValue: 'My onboardings',
          })}
        </Heading>
      </HStack>
    </VStack>
  );
};
